const franchises = [
    {uid: 0, label: 0},
    {uid: 100, label: 100},
    {uid: 200, label: 200},
    {uid: 300, label: 300},
    {uid: 400, label: 400},
    {uid: 500, label: 500},
    {uid: 700, label: 700},
    {uid: 800, label: 800},
    {uid: 1000, label: 1000},
    {uid: 1500, label: 1500},
    {uid: 2000, label: 2000},
    {uid: 2500, label: 2500}
];

export default franchises;